import React, {useState} from "react";
import { Waypoint } from 'react-waypoint';
import _ from "lodash";
import api from "../../api";
import "./Interests.scss";

const InterestFilterSelected = (interests) => {
    return _.map(_.filter(interests, function(interest){

        return interest.isSelected == 1;
    }),_.property('InterestID'));
}

const InterestListEdit = (props) => {
    const[interests, setInterests]                  = useState([]);
    const[paged, setPaged]                          = useState(1);
    const[fetchingInterest, setFetchingInterest]    = useState(false);
    let selectedInterests                           = props.selectedInterests;
    
    const PaginationInterest = () => {
    
        if(fetchingInterest)
        {
            return;
        }
    
        if(!selectedInterests)
        {
            selectedInterests = [];
        }
    
        setFetchingInterest(true);
    
        var Promises = [
            api('/Interest', 'post', {
                paged               : paged
                ,posts_per_page     : props.posts_per_page || 15
                ,selected           : _.map(selectedInterests, _.property('InterestID'))
                ,seleted_only       : props.selected_only || 0
            })
        ];
    
        Promise.all(Promises).then(function(response){
                let ResponseInterest = response[0];
                
                if(ResponseInterest.interest.length > 0)
                {
                    setFetchingInterest(false);
    
                    var NewInterest = _.map(ResponseInterest.interest, function(interest){
    
                        interest.isSelected = _.findIndex(selectedInterests, {InterestID : interest.InterestID}) > -1;
                        
                        return interest;
                    });
    
                    if(interests !== false)
                    {
                        setInterests( interests.concat(NewInterest));
                    }
                    else
                    {
                        setInterests(NewInterest);
                    }
    
                    if(paged == 1)
                    {
                        props.selectInterest(interests);
    
                        if(props.onLoaded)
                        {
                            props.onLoaded(interests)
                        }
                    }
    
                    setPaged(paged + 1);
    
                }
                else
                {
                    setFetchingInterest('EOF');
                }
                
    
            })
    }
    
    const selectInterest = (interest) => {
    
        let InterestToMod = _.clone(interests);
    
        interest.isSelected = !interest.isSelected;
    
        let index = _.findIndex(InterestToMod, interest);
    
        InterestToMod[index] = interest;
        
        setInterests(InterestToMod);
    
        props.selectInterest(InterestToMod);
    }
    
    return (
        <div className="interests-list-container">
            <ul className="interests-lists">
                {
                    interests !== false && interests.map((interest) => {
    
                        return (
                            <li className={"interest " + (interest.isSelected && 'selected') } key={interest.InterestID}>
                                <span 
                                    className="block wrapper"
                                    style={{backgroundImage : 'url('+interest.AttachmentURL+')' }} onClick={() => {selectInterest(interest)}}
                                >
                                    <span className="relative">
                                        {interest.InterestName}
                                    </span>
                                </span>
                            </li>
                        )
                    })
                }
                {
                    fetchingInterest !== 'EOF' && 
                    (
                        <Waypoint onEnter={PaginationInterest} >
                            <li className="interest skeleton-interest">
                            {
                                fetchingInterest && <span className="skeleton"></span> 
                            }
                            </li>
                        </Waypoint>
                    )
                }
            </ul>
            {
                interests !== false && fetchingInterest !== 'EOF' &&
                <div className="text-right text-xs mt-md">
                    Scroll to see all interest
                </div>
            }
        </div>
    )
}

export default InterestListEdit;

export {InterestFilterSelected};